const TOOLBAR_BUTTON_TYPES = {
  COMMAND: 'command',
};

const definitions = [
  {
    id: 'tag-browser',
    label: 'Tag',
    icon: 'list',
    type: TOOLBAR_BUTTON_TYPES.COMMAND,
    commandName: 'openDICOMTagViewer',
  },
];

export default {
  definitions,
  defaultContext: 'ACTIVE_VIEWPORT::CORNERSTONE',
};
